import {
  IconButton as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
  Tooltip,
} from '@mui/material';
import React from 'react';

export type IconButtonProps = Omit<MuiIconButtonProps, 'aria-label'> & {
  /** Required: an icon-only control has no other name. */
  'aria-label': string;
  /** Show the same string as a tooltip on hover and focus. Default true. */
  tooltip?: boolean;
  /**
   * Makes it a link (an <a>, routed by the theme's LinkBehavior), e.g. the
   * phone header's search. `aria-current` then marks the current page.
   */
  href?: string;
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({tooltip = true, ...rest}, ref) => {
    // The Tooltip stays mounted either way, so toggling `disabled` or
    // `tooltip` does not remount the button (and drop its focus). An empty
    // title never opens, and MUI skips its disabled-child warning for it. The
    // button's own aria-label wins over the one Tooltip would add.
    const title = tooltip && !rest.disabled ? rest['aria-label'] : '';
    return (
      <Tooltip title={title}>
        <MuiIconButton ref={ref} {...rest} />
      </Tooltip>
    );
  },
);
IconButton.displayName = 'IconButton';
